<template>
  <router-view v-if="routedVideo" />
  <template v-else>
    <transition-fade :duration="500" appear>
      <div
        v-if="activeSeasonContentForSchoolLevel"
        id="video-list-header"
        class="border-0 border-b border-solid border-gray my-0 mx-[100px] text-center"
      >
        <h1 class="title-block ml-0">
          {{ activeVolume.title }} / {{ activeSeason.issueNumber }}
        </h1>
      </div>
    </transition-fade>
    <transition-fade :duration="500" appear>
      <ul
        v-if="activeSeasonContentForSchoolLevel?.videos?.length"
        id="video-list"
        class="flex flex-wrap justify-center max-h-[calc(100vh_-_209px)] overflow-y-auto"
      >
        <video-preview
          v-for="video in activeSeasonContentForSchoolLevel.videos"
          :key="video.slug"
          is="li"
          :video="video"
          :to="{
            name: 'FilmListVideoPlayer',
            params: {
              ...route.params,
              videoSlug: video.slug,
            },
          }"
        />
      </ul>
      <div v-else class="flex h-full justify-center items-center">
        <box-generic header="Geen materiaal">
          <p class="mt-3 leading-relaxed">
            In deze aflevering zijn er geen filmpjes beschikbaar.<br />
            U kunt altijd filmpjes vinden in het
            <router-link-button :to="{ name: 'FilmArchive' }" class="my-1">
              Filmarchief</router-link-button
            >.
          </p>
        </box-generic>
      </div>
    </transition-fade>
  </template>
</template>

<script>
import { mapState, mapGetters } from "vuex";

import { RouterView } from "vue-router";

import BoxGeneric from "../../../../components/content/BoxGeneric.vue";
import RouterLinkButton from "../../../../components/content/RouterLinkButton.vue";
import VideoPreview from "../../../../components/content/media/VideoPreview.vue";
import TransitionFade from "../../../../components/magic/TransitionFade.vue";

export default {
  name: "FilmList",
  components: {
    BoxGeneric,
    RouterView,
    RouterLinkButton,
    TransitionFade,
    VideoPreview,
  },
  computed: {
    ...mapState(["route"]),
    ...mapGetters([
      "activeVolume",
      "activeSeason",
      "activeSeasonContentForSchoolLevel",
      "routedVideo",
    ]),
  },
};
</script>
